var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EB5A2B",
    d: "M9.562 19.521l-.83 1.662H7.07l.83-1.662h1.662zm8.309 0l.83 1.662H17.04l-.831-1.662h1.662zM9.457 4.031a20.176 20.176 0 016.37-.078l.492.078-.011.064h.01l-.53 3.035c1.274.19 2.224.455 2.656.588l.257.084V17.86l-5.815 1.661L7.07 17.86V7.802l.258-.084a18.412 18.412 0 012.66-.588l-.53-3.034.01-.001-.01-.064zm6.752 11.336a.831.831 0 100 1.662.831.831 0 000-1.662zm-6.647 0a.831.831 0 100 1.662.831.831 0 000-1.662zm7.478-5.816H8.73v3.324c0 .426.321.777.734.825l.097.006h6.647c.426 0 .777-.321.825-.734l.006-.097V9.55zm-4.154-4.568c-.652 0-1.304.034-1.958.102l.39 1.892a19.312 19.312 0 013.14 0l.39-1.892a18.836 18.836 0 00-1.962-.102z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTram);
export default __webpack_public_path__ + "static/media/tram.98b32675f3d991324598e6d30c141d84.svg";
export { ForwardRef as ReactComponent };